import React from "react";

import { Gears } from "../processing-indicators";

import styles from "./Splash.module.scss";

interface ISplashProps {
  appName: string;
  statusText?: string;
  additionalStatusText?: string;
}

export const Splash: React.FC<ISplashProps> = ({ appName, statusText, additionalStatusText }) => {
  return (
    <div className={styles.splash}>
      <h1 className={styles.appName}>{appName}</h1>
      <div className={styles.appInfo}>
        <Gears />
      </div>
      <h4 className={styles.statusText}>{statusText}</h4>
      <h5 className={styles.additionalStatusText}>{additionalStatusText}</h5>
    </div>
  );
};
